import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ShipmentSelectionService } from '../../shared/services/shipment-selection.service';
import { MatLine } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { MatNavList, MatListItem } from '@angular/material/list';

@Component({
    selector: 'app-shipment-table-actions',
    templateUrl: './shipment-table-actions.component.html',
    styleUrls: ['./shipment-table-actions.component.scss'],
    imports: [MatNavList, MatListItem, MatLine, AsyncPipe]
})
export class ShipmentTableActionsComponent implements OnInit {

    constructor(private sheetRef: MatBottomSheetRef<ShipmentTableActionsComponent>, private store: Store<AppState>,
                private shipmentSelectionService: ShipmentSelectionService) {}

    shipButton$ = this.shipmentSelectionService.shipSelectionButton$;
    quoteButton$ = this.shipmentSelectionService.quoteSelectionButton$;
    voidButton$ = this.shipmentSelectionService.voidSelectionButton$;
    printButton$ = this.shipmentSelectionService.printSelectionButton$;
    pickupButton$ = this.shipmentSelectionService.pickupSelectionButton$;
    cancelPickupButton$ = this.shipmentSelectionService.cancelPickupButton$;

    shippableShipments$ = this.shipmentSelectionService.shippableShipments$;
    voidableShipments$ = this.shipmentSelectionService.voidableShipments$;
    printableShipments$ = this.shipmentSelectionService.printableShipments$;
    quotableShipments$ = this.shipmentSelectionService.quotableShipments$;
    pickupShipments$ = this.shipmentSelectionService.pickupShipments$;
    pickups$ = this.shipmentSelectionService.pickups$;

    ngOnInit(): void {
    }

    print(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.printSelection();
    }

    ship(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.submitSelection();
    }

    quote(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.quoteSelection();
    }

    voidShipment(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.voidSelection();
    }

    pickup(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.pickupSelection();
    }

    cancelPickup(): void {
        this.sheetRef.dismiss();
        this.shipmentSelectionService.pickupCancelSelection();
    }

}
